/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import {currencyNumberFormat, translate} from "utils/utility";
import React from "react";
import {PackageItem} from "types/entities/PackageItem";
import {useTranslation} from "react-i18next";
import clsx from "clsx";

interface PackageUpsellItemPriceWithStockProps {
    packageItem: PackageItem;
    className?: string;
    isSeller?: boolean;
    isOption?: boolean;
    classNamePrice?: string;
    classNameStock?: string;
    classNameDiscount?: string;
    quantity?: number;
}

const PackageUpsellItemPriceWithStock = (props: PackageUpsellItemPriceWithStockProps) => {
    const {t} = useTranslation();
    const priceAccordingToQuantity = props?.quantity ? (props.quantity * props.packageItem.price) : props.packageItem.price;
    const discountPriceAccordingToQuantity = props?.quantity ? (props.quantity * props.packageItem.original_price) : props.packageItem.original_price;

    return (
        <div
            className={clsx("className PackageUpsellItemPriceWithStock sm:pr-4 text-right md:text-center flex flex-col space-y-1", props.className)}>
            <b className={clsx("classNamePrice text-lg xl:text-xl text-black font-bold leading-tight md:leading-none", props.isSeller && "leading-none", props.classNamePrice)}>{currencyNumberFormat(priceAccordingToQuantity)}</b>
            {props.packageItem.discount !== 0 && (
                <div className={clsx("classNameDiscount flex flex-row gap-x-3", props.classNameDiscount)}>
                    <div className={"relative"}>
                        <small
                            className={"font-medium text-base text-gray-700"}>{currencyNumberFormat(discountPriceAccordingToQuantity)}</small>
                        <aside
                            className={"absolute w-full transform-gpu -rotate-3 h-px left-0 bottom-1/2 bg-red-400"} />
                    </div>
                    <div
                        className={"rounded-full text-sm px-1 py-px bg-red-400 text-white space-x-0.5 flex items-center justify-center"}>
                        <span>-</span><span>{props.packageItem.discount}%</span>
                    </div>
                </div>
            )}

            <h4
                className={clsx(
                    "font-medium text-gray-900 text-sm lg:text-base leading-none sr-only",
                    // props.classNameStock,
                )}
            >
                {props.packageItem.is_variant
                    ? (
                        <div className={"sr-only"}>
                            {props.packageItem?.variant_description && (
                                (props.quantity && props.quantity > 1)
                                    ? <div className={"flex flex-row gap-x-2 text-right"}>
                                        <div>{props.quantity + "x"}</div>
                                        <div>{translate(props.packageItem.variant_description)}</div>
                                    </div>
                                    : <div>{translate(props.packageItem.variant_description)}</div>
                            )}
                        </div>
                    )
                    : (
                        <span
                            className={"sr-only"}>{props.packageItem.extra.whole_group ? t("Price per person") : t("Price per item")}</span>
                    )
                }
            </h4>
        </div>
    );
};

export default PackageUpsellItemPriceWithStock;
